import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/data.service';
import { modeNev } from 'src/app/mode-nevek';
import { AdminMenuPont, AdminMenuService, AdminMenuTerulet } from '../admin-menu.service';

/**
 *  ADMIN KEZDŐLAP – A KIVÁLASZTOTT TERÜLET (2026-10-16).
 *
 *  A keret bal oldali területlistája ide nyit (`?terulet=`): a terület pontjai alcsoportokban,
 *  kártyán, rövid leírással – ugyanabból a katalógusból és ugyanazzal a láthatósággal, mint a
 *  keret (AdminMenuService). Fölötte a köszöntés, SULINFORM-ban a tanév néhány száma, és a
 *  „gyakran használt” pontok (a böngészőben számolva).
 *
 *  Eddig az /admin egy találomra kiválasztott import-képernyőre ugrott, később csempés
 *  áttekintés volt egy bedrótozott listával – most a katalógus az egyetlen forrás.
 */
@Component({
  selector: 'app-admin-kezdolap',
  templateUrl: './kezdolap.component.html',
  styleUrls: ['./kezdolap.component.scss'],
})
export class AdminKezdolapComponent implements OnInit, OnDestroy {
  sajatIntezmeny: any;
  nev = '';
  munkatanev: number | null = null;
  aktualistanev: number | null = null;

  /** Az aktuális modul – a tanév számai csak SULINFORM-ban. */
  mode = 'SULINFORM';
  get sulinform(): boolean { return this.mode === 'SULINFORM'; }
  get modNev(): string { return modeNev(this.mode); }

  teruletek: AdminMenuTerulet[] = [];
  terulet: AdminMenuTerulet | null = null;
  gyakori: AdminMenuPont[] = [];
  kesz = false;

  /** Számlálók a gyors helyzetképhez (ami nem jön be, az egyszerűen nem látszik). */
  szamok: { [kulcs: string]: number } = {};

  private sub?: Subscription;

  constructor(private data: DataService, private router: Router, private http: HttpClient,
              private route: ActivatedRoute, private menu: AdminMenuService) {}

  async ngOnInit() {
    this.mode = String((await this.data.getFromStorage('currentMode')) || 'SULINFORM');
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    const user = await this.data.getFromStorage('user');
    this.nev = user?.full_name || user?.username || '';
    try { this.teruletek = await this.menu.teruletek(); } catch { this.teruletek = []; }
    this.gyakori = this.menu.gyakori(this.teruletek);
    this.kesz = true;
    this.sub = this.route.queryParamMap.subscribe((qp) => this.valaszt(qp.get('terulet')));
    if (!this.sulinform) return;
    this.munkatanev = await this.data.getMunkatanev();
    this.aktualistanev = await this.data.getAktualisTanev();
    this.szamokBetolt();
  }

  ngOnDestroy() { this.sub?.unsubscribe(); }

  private valaszt(kulcs: string | null) {
    const k = kulcs || this.menu.utolsoTerulet();
    this.terulet = this.teruletek.find((t) => t.kulcs === k) || this.teruletek[0] || null;
    if (this.terulet) this.menu.mentTerulet(this.terulet.kulcs);
  }

  get intezmenyNev(): string {
    return this.sajatIntezmeny?.intezmenyName || this.sajatIntezmeny?.intezmenyId || '';
  }

  get koszones(): string {
    const ora = new Date().getHours();
    if (ora < 10) return 'Jó reggelt';
    if (ora < 18) return 'Jó napot';
    return 'Jó estét';
  }

  get munkatanevEltero(): boolean {
    return this.munkatanev != null && this.aktualistanev != null
      && Number(this.munkatanev) !== Number(this.aktualistanev);
  }

  /** Néhány szám a helyzetképhez. Hiba esetén nem írunk ki semmit – nem tippelünk. */
  private szamokBetolt() {
    const intezmeny = String(this.sajatIntezmeny?.intezmenyId || '').trim();
    if (!intezmeny) return;
    this.http.get<any>(`/api/tanev/statusz/${this.munkatanev}/${intezmeny}`).subscribe({
      next: (r) => {
        if (r?.osztaly != null) this.szamok['osztály'] = r.osztaly;
        if (r?.tanulo != null) this.szamok['tanuló'] = r.tanulo;
        if (r?.csoport != null) this.szamok['csoport'] = r.csoport;
        if (r?.ttf != null) this.szamok['TTF-sor'] = r.ttf;
      },
      error: () => { /* számok nélkül is használható a kezdőlap */ },
    });
  }

  get szamKulcsok(): string[] {
    return Object.keys(this.szamok);
  }

  nyit(ut: string) {
    this.router.navigateByUrl(ut);
  }
}
